import * as ActionType from '../actions/auth';

const defaultState = {};

export default function auth (state = defaultState, action) {
	let newState = { ...state };

  switch (action.type) {
      case ActionType.LOGOUT_SUCCESS:
      case ActionType.LOGOUT_FAILED:

          newState = {
              loggedOut: true
          };

          return newState;

    default:
      return state;
  }

}
